import React from "react";
import classnames from "classnames";
import Moment from "../../../utils/Moment";

export class Notification extends React.Component {
  render() {
    let item = this.props.item;
    const handleSend = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.onSendFailedNotification) {
        this.props.onSendFailedNotification(item);
      }
    };
    const handleDelete = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.onDeleteFailedNotification) {
        this.props.onDeleteFailedNotification(item);
      }
    };
    return (
      <span className="padding-10">
        <em className="badge padding-5 no-border-radius bg-color-blueLight pull-left margin-right-5">
          <i className={classnames(["fa fa-fw fa-2x", item.icon])} />
        </em>
        <span>
          <span className="pull-right">
            <button type="button" className="btn btn-xs btn-default" title="Gửi lại" onClick={handleSend}>
              <i className="fa fa-send" />
            </button>
            <button type="button" className="btn btn-xs btn-default" title="Xóa" onClick={handleDelete}>
              <i className="fa fa-trash" />
            </button>
          </span>
          {item.message}
          <br />
          <span className="pull-right font-xs text-muted">
            <i>{item.time ? <span>on<Moment date={item.time} format="MMMM Do, h:mm a" /></span> : ""}</i>
          </span>
        </span>
      </span>
    );
  }
}
